var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2002 0.999756H4.2002C2.54334 0.999756 1.2002 2.3429 1.2002 3.99976V19.9998C1.2002 21.6566 2.54334 22.9998 4.2002 22.9998H20.2002C21.857 22.9998 23.2002 21.6566 23.2002 19.9998V3.99976C23.2002 2.3429 21.857 0.999756 20.2002 0.999756ZM21.2002 19.9995C21.2002 20.5518 20.7525 20.9995 20.2002 20.9995H4.20019C3.6479 20.9995 3.20019 20.5518 3.20019 19.9995V10.9995H21.2002V19.9995ZM21.2002 9H3.20019V4C3.20019 3.44772 3.6479 3 4.20019 3H20.2002C20.7525 3 21.2002 3.44772 21.2002 4V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.c09198c8.svg";
export { ForwardRef as ReactComponent };